'use client';

import Button from 'molecules/Button';
import Icon from 'molecules/Icon';
import Link from 'molecules/Link';

import styles from 'components/HealthcareEntries/LearningCenterGate/learning-center-gate.module.scss';

import type { FC } from 'react';

interface LearningCenterIndicatorProps {
  slug: string;
  isHCIOnly: boolean;
}

const learningCenterDomain = process.env.NEXT_PUBLIC_LEARNING_CENTER_SITE_DOMAIN || 'https://learning.magmutual.com';

const LearningCenterGate: FC<LearningCenterIndicatorProps> = ({ slug, isHCIOnly }) => {
  const url = isHCIOnly ? `${learningCenterDomain}/content-library` : `${learningCenterDomain}${slug}`;

  return (
    <div className={styles.wrapper}>
      <div className={styles.bottomBox}>
        <h2 className={styles.heading}>Want access to exclusive content and advice?</h2>
        <p className={styles.detail}>
          MagMutual offers a wide variety of industry-leading tools and advice to help healthcare providers mitigate
          their liability risk. Become a PolicyOwner today.
        </p>
        <div className={styles.buttonContainer}>
          <Button className={styles.quoteButton} color="gray" url="/quote">
            Get a Quote
          </Button>
          <Button className={styles.myButton} url={url} target="_self">
            MyMagMutual
          </Button>
        </div>
        <Link className={styles.link} href="/products-overview">
          Learn more about our products
          <Icon icon="arrow-right" size={14} />
        </Link>
      </div>
    </div>
  );
};

export default LearningCenterGate;
